lookupFragment